<template>
  <v-container max-width="100%" style="margin-top: 2%">
    <!-- Confirm Dialog (delete / status) -->
    <v-row justify="center">
      <v-dialog v-model="confirmDialog" persistent max-width="500">
        <v-card>
          <v-card-title class="headline">
            <span style="color: #d60000">{{ $t('system.alert') }}</span>
          </v-card-title>
          <v-card-text>
            <span style="color: #d60000">{{ mensagemdialog }}</span>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red accent-4" class="white--text" @click="confirmDialog = false">{{ messageDismissButton }}</v-btn>
            <v-btn v-if="showConfirmButton && confirmDialogType === 'delete'" color="red accent-4" class="white--text" @click="deleteFromDatabase">{{ messageConfirmButton }}</v-btn>
            <v-btn v-if="showConfirmButton && confirmDialogType === 'status'" color="primary" class="white--text" @click="confirmStatusUpdate">{{ messageConfirmButton }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-row>

    <!--
      Topo num card só: filtro por veículo (recorta todas as abas e resume o veículo), abas da
      tela e, nos validadores, as sub-abas do painel.
    -->
    <v-card outlined class="mb-3 equipamentos-topo">
      <div class="px-3 pt-1 pb-2">
        <v-row dense align="center">
          <v-col cols="12" sm="6" md="4">
            <LazySelect
              ref="filtroVeiculo"
              get-url="getVeiculoslazy"
              text="cod_veiculo"
              value="id_veiculo"
              icon="mdi-bus"
              :label="$t('equipment.panel.vehicleFilter')"
              @input="onFiltroVeiculo"
            />
          </v-col>
          <v-col cols="auto">
            <AjudaTooltip :texto="$t('equipment.help.vehicleFilter')" />
          </v-col>
        </v-row>
        <ResumoVeiculo
          v-if="idVeiculoFiltro != null"
          :id-veiculo="idVeiculoFiltro"
          :cod-veiculo="codVeiculoFiltro"
          :equipamentos="equipamentosDoVeiculo"
          @abrir="abrirDoResumo"
        />
      </div>
      <v-divider></v-divider>
      <v-tabs v-model="mainTab" show-arrows>
        <v-tab v-for="aba in abas" :key="aba.key" :href="`#${aba.key}`">
          <v-icon small left>{{ aba.icon }}</v-icon>
          {{ aba.label }}
          <v-chip v-if="aba.count != null" x-small class="ml-1">{{ aba.count }}</v-chip>
          <AjudaTooltip v-if="aba.help" x-small class="ml-1" :texto="aba.help" />
        </v-tab>
      </v-tabs>
      <template v-if="mainTab === CLASSE_VALIDADOR && subAbasValidadores.length > 1">
        <v-divider></v-divider>
        <v-tabs v-model="subAbaValidadores" show-arrows height="38">
          <v-tab v-for="aba in subAbasValidadores" :key="aba.key" :href="`#${aba.key}`" class="text-none">
            <v-icon small left>{{ aba.icon }}</v-icon>
            {{ aba.label }}
            <v-chip v-if="aba.badge" x-small dark color="orange darken-2" class="ml-1">{{ aba.badge }}</v-chip>
            <AjudaTooltip v-if="aba.help" x-small class="ml-1" :texto="aba.help" />
          </v-tab>
        </v-tabs>
      </template>
    </v-card>

    <!-- Só a aba ativa fica montada: cada uma pagina a própria tabela. -->
    <TabelaEquipamentos
      v-if="mainTab === CLASSE_RASTREADOR || mainTab === CLASSE_OUTRO"
      ref="tabelaClasse"
      :key="mainTab"
      :titulo="tituloAba"
      :itens="equipamentosDaAba"
      :loading="loadingtable"
      :token="token"
      :mostrar-inativos.sync="mostrarInativos"
      :permissoes="permissoesCadastro"
      :headers-csv="headersCSV"
      :help-csv="helpCSV"
      :categoria-de="getCategoriaTipoEquipamento"
      v-on="ouvintesCadastro"
    />
    <PainelValidadores
      v-else-if="mainTab === CLASSE_VALIDADOR"
      ref="painelValidadores"
      :validadores="equipamentosDaAba"
      :loading="loadingtable"
      :token="token"
      :mostrar-inativos.sync="mostrarInativos"
      :permissoes="permissoesValidadores"
      :headers-csv="headersCSV"
      :help-csv="helpCSV"
      :id-veiculo="idVeiculoFiltro"
      :isapi-na-instalacao="isapiNaInstalacao"
      :sub-aba.sync="subAbaValidadores"
      v-on="ouvintesCadastro"
      @sub-abas="subAbasValidadores = $event"
    />
    <CRUDKits v-else-if="mainTab === 'KITS'" class="crud-kits-embed" />

    <v-dialog v-model="dialog" fullscreen max-width="100%">
      <v-card>
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="close">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn 
              v-if="!isBulkEdit && editedIndex !== -1 && editedItem.id_equipamento" 
              dark text 
              @click="downloadIndividualQRCode"
              :loading="downloadingIndividualQRCode"
              :title="$t('equipment.qrcode.downloadIndividual')"
            >
              <v-icon left>mdi-qrcode</v-icon>
              {{ $t('equipment.qrcode.downloadIndividual') }}
            </v-btn>
            <v-btn dark text @click="save">{{ $t('button.save') }}</v-btn>
          </v-toolbar-items>
        </v-toolbar>

        <v-card-text>
          <v-container>
            <v-form ref="form" v-model="formValidado">
              <div class="secao-form">
                <v-icon small class="mr-2">mdi-card-account-details-outline</v-icon>
                {{ $t('equipment.sections.identification') }}
              </div>
              <v-row>
                <v-col v-if="!isBulkEdit" cols="12" sm="6" md="5">
                  <v-text-field v-model="editedItem.nome_equipamento" :label="$t('equipment.name')"
                    item-value="nome_equipamento" clearable
                    :rules="[(v) => !!v || $t('equipment.nameRequired')]"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="5">
                  <v-autocomplete v-model="editedItem.id_empresa" :items="empresas" item-text="razao_social"
                    item-value="id_empresa" clearable :label="$tc('company.self', 1)"
                    :rules="isBulkEdit ? [] : [(v) => !!v || $t('equipment.companyRequired')]"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="2">
                  <v-switch v-model="isAtivo" class="ma-2" :label="$t('equipment.active')"></v-switch>
                </v-col>
              </v-row>
              <v-row v-if="!isBulkEdit">
                <v-col cols="12" sm="6" md="4">
                  <v-autocomplete v-model="editedItem.id_tipo_equipamento" :items="tiposequipamentos"
                    item-text="nome_tipo_equipamento" item-value="id_tipo_equipamento" clearable
                    :label="$t('equipment.type')"
                    :rules="[(v) => !!v || $t('equipment.typeRequired')]">
                    <template v-if="classeTipoForm" v-slot:append-outer>
                      <AjudaTooltip :texto="$t('equipment.panel.typeClassHint', { classe: classeTipoForm })" />
                    </template>
                  </v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field
                  v-model="editedItem.cod_equipamento" 
                    :label="$t('equipment.code')"
                    clearable
                    :rules="[codEquipamentoRules]"
                    persistent-hint
                  ></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-autocomplete v-model="editedItem.id_status_equipamento" :items="statusEquipamentos"
                    item-text="descricao_status_equipamento" item-value="id_status_equipamento"
                    :label="$t('equipment.status')"></v-autocomplete>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="editedItem.numero_serie" :label="$t('equipment.serialNumber')"
                    :rules="[numeroSerieRules]">
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="editedItem.modelo" :label="$t('system.labels.model')"
                    :rules="[modeloRules]"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="editedItem.imei" v-mask="'##-######-######-#'"
                    :label="$t('equipment.imei')" :rules="[imeiRules]"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <div class="d-flex align-center">
                    <LazySelect
                      ref="inventarioSelect"
                      class="flex-grow-1"
                      get-url="getAvailableqrcodesequipamentoslazy"
                      text="codigo"
                      value="codigo"
                      :label="$t('equipment.codigoQrcode')"
                      @input="onInventarioSelect"
                    />
                    <v-btn icon small class="ml-1" @click="openQRScanner" color="primary">
                      <v-icon>mdi-qrcode-scan</v-icon>
                    </v-btn>
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-dialog fullscreen v-model="qrcodeDialog">
                    <template v-slot:activator="{ on, attrs }">
                      <v-img
                        :src="qrcodeImageSrc"
                        height="10vh" width="5vw" min-height="100px" min-width="120px"
                        style="padding: 10px; margin: 5px; border: 1px solid #4a4a4a; border-radius: 5px; box-shadow: #4a4a4a 1px 1px 5px; cursor: pointer;"
                        v-on="editedItem.codigo_qrcode ? on : {}"
                        v-bind="attrs">
                        <template v-slot:placeholder>
                          <v-row class="fill-height ma-0" align="center" justify="center">
                            <v-icon size="48" color="grey">mdi-qrcode</v-icon>
                          </v-row>
                        </template>
                      </v-img>
                    </template>
                    <v-card>
                      <v-toolbar color="primary" dark>
                        <v-toolbar-title>{{ $t('equipment.codigoQrcode') }}</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                          v-if="editedItem.id_equipamento"
                          dark
                          color="primary"
                          depressed
                          @click="downloadIndividualQRCode"
                          :loading="downloadingIndividualQRCode"
                        >
                          {{ $t('equipment.qrcode.downloadIndividual') }}
                        </v-btn>
                        <v-btn dark color="primary" depressed @click="qrcodeDialog = false">
                          {{ $t('button.close') }}
                        </v-btn>
                      </v-toolbar>
                      <v-card-text style="height: 80vh;">
                        <div style="height: 100%; display: flex; flex-direction: column; align-items: center; justify-content: center;">
                          <v-img
                            v-if="qrcodeImageSrc"
                            :src="qrcodeImageSrc"
                            height="400px"
                            width="400px"
                            min-height="70px"
                            min-width="100px"
                            contain
                            style="padding: 10px; margin: 5px;">
                          </v-img>
                          <v-row v-else justify="center" align="center" style="min-height: 200px;">
                            <v-icon size="120" color="grey">mdi-qrcode</v-icon>
                          </v-row>
                          <v-row v-if="editedItem.codigo_qrcode" justify="center" style="margin-top: 10px;">
                            <div>{{ editedItem.codigo_qrcode }}</div>
                          </v-row>
                        </div>
                      </v-card-text>
                    </v-card>
                  </v-dialog>
                </v-col>
              </v-row>

              <div class="secao-form">
                <v-icon small class="mr-2">mdi-link-variant</v-icon>
                {{ $t('equipment.sections.link') }}
              </div>
              <v-row v-if="!isBulkEdit">
                <v-col cols="12" sm="6" md="4">
                  <div class="d-flex align-center">
                    <LazySelect
                      ref="veiculoSelect"
                      class="flex-grow-1"
                      get-url="getVeiculoslazy"
                      text="cod_veiculo"
                      value="id_veiculo"
                      :label="$t('equipment.vehicle')"
                      @input="onVeiculoSelect"
                    />
                    <AjudaTooltip v-if="usaIsapiNoForm && editedItem.provedor_ip" class="ml-1"
                      :texto="$t('equipment.vehicleProviderHint')" />
                  </div>
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <v-text-field v-model="editedItem.cod_integracao"
                    :label="$t('equipment.integrationCode')">
                    <template v-if="isFaceId && suiteEfetivaForm === 'HIKCENTRAL'" v-slot:append-outer>
                      <AjudaTooltip :texto="$t('equipment.integrationCodeHikHint')" />
                    </template>
                  </v-text-field>
                </v-col>
                <v-col cols="12" sm="6" md="4" v-if="setup.has_hikvision == 1 && !isFaceId">
                  <v-autocomplete v-model="editedItem.cod_integracao_nivel_acesso" :items="niveisAcesso"
                    item-text="privilegeGroupName" item-value="privilegeGroupId" clearable
                    :label="$t('equipment.integrationLevelAccess')"></v-autocomplete>
                  <v-alert v-if="alertaNivelAcesso" type="warning" dense text class="mt-1 mb-0">
                    {{ $t(`equipment.levelAccessAlert.${alertaNivelAcesso}`) }}
                  </v-alert>
                </v-col>
              </v-row>
              <v-row v-if="isBulkEdit">
                <v-col cols="12" sm="6" md="6">
                  <LazySelect
                    ref="veiculoSelectBulk"
                    get-url="getVeiculoslazy"
                    text="cod_veiculo"
                    value="id_veiculo"
                    :label="$t('equipment.vehicle')"
                    @input="onVeiculoSelect"
                  />
                </v-col>
              </v-row>

              <template v-if="mostraSecaoComunicacao">
                <div class="secao-form">
                  <v-icon small class="mr-2">mdi-face-recognition</v-icon>
                  {{ $t('equipment.sections.communication') }}
                  <AjudaTooltip class="ml-2" :texto="$t('equipment.help.communicationSection')" />
                </div>

                <!-- Situação gravada: o que o monitor usa hoje, antes de qualquer alteração no form. -->
                <v-sheet v-if="editedIndex !== -1" outlined rounded class="pa-3 mb-4">
                  <div class="d-flex align-center mb-2">
                    <span class="text-subtitle-2">{{ $t('equipment.current.title') }}</span>
                    <AjudaTooltip class="ml-2" x-small :texto="$t('equipment.current.caption')" />
                  </div>
                  <v-row dense>
                    <v-col cols="12" sm="6" md="3">
                      <div class="text-caption grey--text">{{ $t('equipment.current.suite') }}</div>
                      <div>
                        {{ editedItem.nome_suite_efetiva || editedItem.suite_efetiva || '—' }}
                        <v-chip v-if="editedItem.suite_definida_no_equipamento == 0" x-small class="ml-1">
                          {{ $t('equipment.current.suiteDefault') }}
                        </v-chip>
                      </div>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <div class="text-caption grey--text">{{ $t('equipment.current.communication') }}</div>
                      <div>
                        <v-icon small :color="corComunicacao(editedItem.status)">{{ iconeComunicacao(editedItem.status) }}</v-icon>
                        {{ fmtStatusComunicacao(editedItem.status) }}
                      </div>
                      <div v-if="editedItem.dt_ultima_atualizacao_comunicacao" class="text-caption">
                        {{ fmtDataHora(editedItem.dt_ultima_atualizacao_comunicacao) }}
                      </div>
                    </v-col>
                    <v-col v-if="editedItem.suite_efetiva === 'ISAPI'" cols="12" sm="6" md="3">
                      <div class="text-caption grey--text">{{ $t('equipment.current.address') }}</div>
                      <div>
                        {{ editedItem.ip_isapi_efetivo ? `${editedItem.ip_isapi_efetivo}:${editedItem.porta_isapi || 443}` : $t('equipment.current.noAddress') }}
                      </div>
                      <div v-if="editedItem.nome_provedor_ip" class="text-caption">
                        {{ $t('equipment.current.viaProvider', { provider: editedItem.nome_provedor_ip }) }}
                      </div>
                    </v-col>
                    <v-col v-if="editedItem.suite_efetiva === 'ISAPI'" cols="12" sm="6" md="3">
                      <div class="text-caption grey--text">{{ $t('equipment.current.firmware') }}</div>
                      <div>{{ editedItem.firmware_version_efetivo || '—' }}</div>
                      <div class="text-caption">
                        {{ editedItem.firmware_released_date_efetivo || '—' }}
                        <v-chip x-small dark class="ml-1" :color="editedItem.firmware_permitido == 1 ? 'green' : 'red'">
                          {{ editedItem.firmware_permitido == 1 ? $t('equipment.current.firmwareAllowed') : $t('equipment.current.firmwareNotAllowed') }}
                        </v-chip>
                      </div>
                    </v-col>
                    <v-col v-if="editedItem.suite_suporta_inventario == 1" cols="12" sm="6" md="3">
                      <div class="text-caption grey--text">{{ $t('equipment.current.lastSync') }}</div>
                      <div>
                        <v-chip x-small dark :color="corResultadoSincronizacao(editedItem.status_ultima_sincronizacao)">
                          {{ fmtResultadoSincronizacao(editedItem.status_ultima_sincronizacao) }}
                        </v-chip>
                        <span v-if="editedItem.dt_ultima_sincronizacao" class="text-caption ml-1">
                          {{ fmtDataHora(editedItem.dt_ultima_sincronizacao) }}
                        </span>
                      </div>
                      <!-- Inventário da suite que o gravou: aparelho (ISAPI) ou nível de acesso (HikCentral). -->
                      <div v-if="editedItem.inventario_fonte === 'NIVEL_ACESSO'" class="text-caption">
                        {{ $t('equipment.current.peopleInAccessLevel', { people: fmtNumero(editedItem.inventario_qtd_pessoas) }) }}
                      </div>
                      <div v-else class="text-caption">
                        {{ $t('equipment.current.peopleCards', { people: fmtNumero(editedItem.inventario_qtd_pessoas), cards: fmtNumero(editedItem.inventario_qtd_cartoes) }) }}
                      </div>
                      <div v-if="editedItem.status_ultima_sincronizacao === 'erro' && editedItem.msg_ultima_sincronizacao"
                        class="text-caption red--text">
                        {{ editedItem.msg_ultima_sincronizacao }}
                      </div>
                    </v-col>
                  </v-row>
                </v-sheet>

                <v-row v-if="mostraSuiteComunicacao">
                  <v-col cols="12" md="6">
                    <v-select v-model="editedItem.suite_comunicacao" :items="suitesComunicacao"
                      item-text="nome_suite" item-value="cod_suite" clearable
                      :label="$t('equipment.communicationSuite')">
                      <template v-slot:append-outer><AjudaTooltip :texto="ajudaSuiteComunicacao" /></template>
                    </v-select>
                  </v-col>
                </v-row>

                <template v-if="usaIsapiNoForm">
                  <div class="subsecao-form">
                  {{ $t('equipment.sections.isapiConnection') }}
                  <AjudaTooltip class="ml-1" x-small :texto="`${$t('equipment.isapiCaption')} ${$t('equipment.help.ipProvider')}`" />
                </div>
                  <v-row>
                    <v-col cols="12" sm="6" md="4">
                      <v-select v-model="editedItem.provedor_ip" :items="provedoresIp"
                        item-text="nome_provedor_ip" item-value="cod_provedor_ip" clearable
                        :label="$t('equipment.ipProvider')">
                        <template v-slot:append-outer><AjudaTooltip :texto="editedItem.provedor_ip ? $t('equipment.isapiIpFromProviderHint') : $t('equipment.ipProviderHint')" /></template>
                      </v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="5">
                      <v-text-field v-model="editedItem.ip_isapi"
                        :disabled="!!editedItem.provedor_ip"
                        :label="$t('equipment.isapiIp')">
                        <template v-slot:append-outer><AjudaTooltip :texto="editedItem.provedor_ip ? $t('equipment.isapiIpFromProviderHint') : $t('equipment.isapiIpHint')" /></template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="3">
                      <v-text-field v-model="editedItem.porta_isapi" type="number"
                        :label="$t('equipment.isapiPort')">
                        <template v-slot:append-outer><AjudaTooltip :texto="$t('equipment.isapiPortHint')" /></template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field v-model="editedItem.usuario_isapi"
                        :label="$t('equipment.isapiUsername')" autocomplete="off">
                        <template v-slot:append-outer><AjudaTooltip :texto="$t('equipment.isapiUsernameHint')" /></template>
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                      <v-text-field v-model="editedItem.senha_isapi" :type="mostraSenhaIsapi ? 'text' : 'password'"
                        :append-icon="mostraSenhaIsapi ? 'mdi-eye-off' : 'mdi-eye'"
                        @click:append="mostraSenhaIsapi = !mostraSenhaIsapi"
                        :label="$t('equipment.isapiPassword')"
                        autocomplete="new-password">
                        <template v-slot:append-outer><AjudaTooltip :texto="editedItem.senha_isapi_definida == 1 ? $t('equipment.isapiPasswordKeepHint') : $t('equipment.isapiPasswordHint')" /></template>
                      </v-text-field>
                    </v-col>
                    <!-- Com provedor vale o firmware do DVR do veículo; sem ele, o informado aqui. -->
                    <template v-if="editedItem.provedor_ip">
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field :value="firmwareForm.version || '—'" disabled
                          :label="$t('equipment.firmwareVersion')"
                          >
                          <template v-slot:append-outer><AjudaTooltip :texto="firmwareForm.veiculoAlterado ? $t('equipment.firmwareVehicleChangedHint') : $t('equipment.firmwareFromProviderHint')" /></template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field :value="firmwareForm.releasedDate || '—'" disabled
                          :label="$t('equipment.firmwareReleasedDate')"></v-text-field>
                      </v-col>
                    </template>
                    <template v-else>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="editedItem.firmware_version" :label="$t('equipment.firmwareVersion')"
                          counter="50"
                          :rules="[(v) => !v || v.length <= 50 || $t('equipment.firmwareMaxLength')]">
                          <template v-slot:append-outer><AjudaTooltip :texto="$t('equipment.firmwareVersionHint')" /></template>
                        </v-text-field>
                      </v-col>
                      <v-col cols="12" sm="6" md="6">
                        <v-text-field v-model="editedItem.firmware_released_date" :label="$t('equipment.firmwareReleasedDate')"
                          counter="50"
                          :rules="[(v) => !v || v.length <= 50 || $t('equipment.firmwareMaxLength')]">
                          <template v-slot:append-outer><AjudaTooltip :texto="$t('equipment.firmwareReleasedDateHint')" /></template>
                        </v-text-field>
                      </v-col>
                    </template>
                  </v-row>
                  <v-alert v-if="avisoFirmware" type="error" dense text class="mt-3">
                    {{ avisoFirmware }}
                  </v-alert>
                  <v-alert v-if="pendenciasIsapi.length" type="warning" dense text class="mt-3">
                    {{ $t('equipment.isapiPending.title') }}
                    <ul class="mb-0">
                      <li v-for="p in pendenciasIsapi" :key="p">{{ $t(`equipment.isapiPending.${p}`) }}</li>
                    </ul>
                  </v-alert>
                </template>

                <template v-else-if="suiteEfetivaForm === 'HIKCENTRAL' && setup.has_hikvision == 1">
                  <div class="subsecao-form">
                  {{ $t('equipment.sections.hikcentral') }}
                  <AjudaTooltip class="ml-1" x-small :texto="`${$t('equipment.hikcentralCaption')} ${$t('equipment.help.accessLevel')}`" />
                </div>
                  <v-row>
                    <v-col cols="12" sm="6" md="6">
                      <v-autocomplete v-model="editedItem.cod_integracao_nivel_acesso" :items="niveisAcesso"
                        item-text="privilegeGroupName" item-value="privilegeGroupId" clearable
                        :label="$t('equipment.integrationLevelAccess')">
                        <template v-slot:append-outer><AjudaTooltip :texto="$t('equipment.integrationLevelAccessHint')" /></template>
                      </v-autocomplete>
                      <v-alert v-if="alertaNivelAcesso" type="warning" dense text class="mt-3 mb-0">
                        {{ $t(`equipment.levelAccessAlert.${alertaNivelAcesso}`) }}
                      </v-alert>
                    </v-col>
                  </v-row>
                </template>
              </template>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Equipment QR Scanner Dialog -->
    <v-dialog v-model="qrScannerDialog" max-width="800" persistent>
      <v-card>
        <v-toolbar dark color="primary">
          <v-toolbar-title>{{ $t('equipment.qrScanner.title') }}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon dark @click="closeQRScanner">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container>
            <v-alert v-if="qrScannerError" type="error" dense class="mb-4">
              {{ qrScannerError }}
            </v-alert>
            <v-alert type="info" dense class="mb-4">
              {{ $t('equipment.qrScanner.instructions') }}
            </v-alert>
            <div style="position: relative; width: 100%; max-width: 600px; margin: 0 auto;">
              <qrcode-stream
                v-if="qrScannerDialog"
                @decode="onQRDecode"
                @init="onQRInit"
                :camera="qrCamera"
                style="width: 100%; border-radius: 8px;"
              ></qrcode-stream>
            </div>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="closeQRScanner">
            {{ $t('button.cancel') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <DownloadQRDialog v-model="downloadQRDialogOpen" :token="token" />
  </v-container>
</template>

<script>

import apiController from "@/utils/apiController";
import QRCode from "qrcode";
import { ApiBaseUrl } from "@/constants";
import { validador } from "@/constants";
import EventBus from "@/utils/eventBus";
import { QrcodeStream } from "vue-qrcode-reader";
import DownloadQRDialog from "./Dialogs/DownloadQRDialog.vue";
import CRUDKits from "./CRUDKits.vue";
import LazySelect from "./Selects/LazySelect.vue";
import dispositivosFormatters from "./Equipamentos/Validadores/dispositivosFormatters";
import TabelaEquipamentos from "./Equipamentos/TabelaEquipamentos.vue";
import PainelValidadores from "./Equipamentos/Validadores/PainelValidadores.vue";
import ResumoVeiculo from "./Equipamentos/ResumoVeiculo.vue";
import AjudaTooltip from "./Equipamentos/AjudaTooltip.vue";
import {
  TIPO_FACEID,
  CLASSE_RASTREADOR,
  CLASSE_VALIDADOR,
  CLASSE_OUTRO,
  ICONE_CLASSE,
  classeDoEquipamento,
} from "./Equipamentos/equipamentosClasses";

/**
 * Tela de Equipamentos: cadastro de todos os equipamentos, separado por classe do tipo
 * (Rastreadores / Validadores / Outros), com o filtro por veículo valendo para todas as abas.
 * Na aba Validadores entram o estado de envio e os módulos das suites (ISAPI, HikCentral),
 * que antes eram as telas Status dos Dispositivos, Hikvision e Firmwares ISAPI.
 * O formulário, os diálogos e as gravações são únicos e ficam aqui; as abas só emitem ações.
 */
export default {
  components: {
    QrcodeStream,
    DownloadQRDialog,
    CRUDKits,
    LazySelect,
    TabelaEquipamentos,
    PainelValidadores,
    ResumoVeiculo,
    AjudaTooltip,
  },
  mixins: [dispositivosFormatters],
  data: () => ({
    CLASSE_RASTREADOR,
    CLASSE_VALIDADOR,
    CLASSE_OUTRO,
    mainTab: CLASSE_RASTREADOR,
    // Sub-abas do painel de validadores: a lista vem do painel, a barra fica no card do topo.
    subAbaValidadores: 'cadastro',
    subAbasValidadores: [],
    idVeiculoFiltro: null,
    codVeiculoFiltro: null,
    // ?equipamento= já aplicado: a lista recarrega a cada gravação e não deve puxar a tela de volta.
    equipamentoRotaAplicado: null,
    user: null,
    token: null,
    search: "",
    showConfirmButton: true,
    formValidado: true,
    dialog: false,
    operacao: 0,
    isAtivo: true,
    confirmDialog: false,
    confirmDialogType: 'delete', // 'delete' or 'status'
    mensagemdialog: "",
    nextStatusInfo: null,
    disableVeiculo: true,
    loadingtable: true,
    mostrarInativos: false,
    equipamentos: [],
    empresas: [],
    tiposequipamentos: [],
    niveisAcesso: [],
    suitesComunicacao: [],
    provedoresIp: [],
    statusEquipamentos: [],
    editedIndex: -1,
    editedItem: {
      nome_equipamento: null,
      id_equipamento: null,
      id_empresa: null,
      cod_equipamento: null,
      codigo_qrcode: null,
      numero_serie: null,
      id_tipo_equipamento: null,
      ativo: null,
      ativo_extenso: null,
      imei: null,
      modelo: null,
      id_veiculo: null,
      cod_veiculo: null,
      cod_integracao: null,
      cod_integracao_nivel_acesso: null,
      ip_isapi: null,
      porta_isapi: 443,
      usuario_isapi: null,
      senha_isapi: null,
      suite_comunicacao: null,
      provedor_ip: null,
      firmware_version: null,
      firmware_released_date: null,
      senha_isapi_definida: 0,
      id_status_equipamento: 0,
      descricao_status_equipamento: null,
      qrcode_uri: null,
      qrcode_no: null,
    },
    deletedItem: {
      nome_equipamento: null,
      id_equipamento: null,
      id_empresa: null,
      cod_equipamento: null,
      codigo_qrcode: null,
      numero_serie: null,
      id_tipo_equipamento: null,
      ativo: null,
      ativo_extenso: null,
      imei: null,
      modelo: null,
      id_veiculo: null,
      cod_veiculo: null,
      cod_integracao: null,
      cod_integracao_nivel_acesso: null,
      ip_isapi: null,
      porta_isapi: 443,
      usuario_isapi: null,
      senha_isapi: null,
      suite_comunicacao: null,
      provedor_ip: null,
      firmware_version: null,
      firmware_released_date: null,
      senha_isapi_definida: 0,
      id_status_equipamento: null,
      descricao_status_equipamento: null,
      qrcode_uri: null,
      qrcode_no: null,
    },
    defaultItem: {
      nome_equipamento: null,
      id_equipamento: null,
      id_empresa: null,
      cod_equipamento: null,
      codigo_qrcode: null,
      numero_serie: null,
      id_tipo_equipamento: null,
      ativo: null,
      ativo_extenso: null,
      imei: null,
      modelo: null,
      id_veiculo: null,
      cod_veiculo: null,
      cod_integracao: null,
      cod_integracao_nivel_acesso: null,
      ip_isapi: null,
      porta_isapi: 443,
      usuario_isapi: null,
      senha_isapi: null,
      suite_comunicacao: null,
      provedor_ip: null,
      firmware_version: null,
      firmware_released_date: null,
      senha_isapi_definida: 0,
      id_status_equipamento: 0,
      descricao_status_equipamento: null,
      qrcode_uri: null,
      qrcode_no: null,
    },
    setup: {
      has_hikvision: 0,
      has_isapi: 0,
      suite_comunicacao_default: null,
    },
    arquivoCsv: null,
    recursos: [],
    canInsert: false,
    canEdit: false,
    canDelete: false,
    // Rotas das suites que a aba Validadores usa (legado e modelo novo chegam aqui igual).
    rotasUsuario: new Set(),
    qrScannerDialog: false,
    qrScannerError: null,
    qrCamera: 'auto',
    downloadQRDialogOpen: false,
    downloadingIndividualQRCode: false,
    selectedEquipamentos: [],
    isBulkEdit: false,
    qrcodeDialog: false,
    qrcodePreviewUrl: null,
    mostraSenhaIsapi: false,
    firmwaresPermitidos: null,
    idVeiculoOriginal: null,
  }),
  computed: {
    // O select só faz sentido quando há mais de uma suite possível na instalação:
    // ISAPI ligado, ou um default de suite já configurado no setup.
    mostraSuiteComunicacao() {
      return this.setup.has_isapi == 1
        || (this.setup.suite_comunicacao_default != null && this.setup.suite_comunicacao_default !== '');
    },
    isFaceId() {
      return this.editedItem.id_tipo_equipamento == TIPO_FACEID;
    },
    // Em que aba o equipamento vai aparecer: a classe vem do tipo escolhido.
    classeTipoForm() {
      if (this.isBulkEdit || this.editedItem.id_tipo_equipamento == null) return null;
      const tipo = (this.tiposequipamentos || []).find((t) => t.id_tipo_equipamento === this.editedItem.id_tipo_equipamento);
      if (!tipo) return null;
      return this.$t(`equipment.panel.classes.${classeDoEquipamento(tipo)}`);
    },
    // Aviso do nível gravado: desativado no HikCentral ou fora da lista de níveis guardada
    // pelo inventário. Nível recém-escolhido no select vem da lista viva e não é avisado.
    alertaNivelAcesso() {
      const cod = this.editedItem.cod_integracao_nivel_acesso;
      if (!cod || this.editedItem.id_equipamento == null) return null;
      const salvo = (this.equipamentos || []).find((e) => e.id_equipamento === this.editedItem.id_equipamento);
      if (!salvo || salvo.cod_integracao_nivel_acesso !== cod) return null;
      if (salvo.nivel_acesso_situacao === 'INATIVO') return 'inactive';
      if (salvo.nivel_acesso_situacao === 'NAO_ENCONTRADO') return 'notFound';
      return null;
    },
    // Seção de comunicação: FaceID em instalação que tem alguma suite a escolher ou HikCentral.
    mostraSecaoComunicacao() {
      return !this.isBulkEdit && this.isFaceId
        && (this.mostraSuiteComunicacao || this.setup.has_hikvision == 1);
    },
    // Mesma resolução da API (getAllEquipamentos) e do monitor: equipamento → default → has_isapi.
    suitePadraoSistema() {
      if (this.setup.suite_comunicacao_default != null && this.setup.suite_comunicacao_default !== '') {
        return this.setup.suite_comunicacao_default;
      }
      return this.setup.has_isapi == 1 ? 'ISAPI' : 'HIKCENTRAL';
    },
    suiteEfetivaForm() {
      return this.editedItem.suite_comunicacao || this.suitePadraoSistema;
    },
    suiteFormInfo() {
      return (this.suitesComunicacao || []).find((s) => s.cod_suite === this.suiteEfetivaForm) || null;
    },
    ajudaSuiteComunicacao() {
      const partes = [this.$t('equipment.help.communicationSuite'), this.hintSuiteComunicacao];
      if (this.suiteFormInfo && this.suiteFormInfo.descricao_suite) partes.push(this.suiteFormInfo.descricao_suite);
      return partes.join(' ');
    },
    hintSuiteComunicacao() {
      if (this.editedItem.suite_comunicacao) {
        return this.$t('equipment.communicationSuiteExplicitHint');
      }
      const padrao = (this.suitesComunicacao || []).find((s) => s.cod_suite === this.suitePadraoSistema);
      return this.$t('equipment.communicationSuiteHint', { suite: padrao ? padrao.nome_suite : this.suitePadraoSistema });
    },
    usaIsapiNoForm() {
      return this.mostraSecaoComunicacao && this.suiteEfetivaForm === 'ISAPI';
    },
    // Espelha os filtros do monitor (inventory/sync_acesso): sem endereço, usuário e senha
    // o aparelho é ignorado em silêncio, então o form avisa antes de salvar.
    pendenciasIsapi() {
      if (!this.usaIsapiNoForm) return [];
      const vazio = (v) => v == null || String(v).trim() === '';
      const pend = [];
      if (this.editedItem.provedor_ip) {
        if (this.editedItem.id_veiculo == null) pend.push('vehicle');
      } else if (vazio(this.editedItem.ip_isapi)) {
        pend.push('address');
      }
      if (vazio(this.editedItem.usuario_isapi)) pend.push('username');
      if (this.editedItem.senha_isapi_definida != 1 && vazio(this.editedItem.senha_isapi)) pend.push('password');
      return pend;
    },
    // Firmware que o monitor vai considerar: do DVR do veículo (provedor) ou o do cadastro.
    // O do DVR vem da listagem, então só vale para o veículo que já está gravado.
    firmwareForm() {
      const texto = (v) => (v != null && String(v).trim() !== '' ? String(v).trim() : null);
      if (this.editedItem.provedor_ip) {
        if (this.editedItem.id_veiculo != this.idVeiculoOriginal) {
          return { version: null, releasedDate: null, veiculoAlterado: true };
        }
        return {
          version: texto(this.editedItem.firmware_version_dvr),
          releasedDate: texto(this.editedItem.firmware_released_date_dvr),
          veiculoAlterado: false,
        };
      }
      return {
        version: texto(this.editedItem.firmware_version),
        releasedDate: texto(this.editedItem.firmware_released_date),
        veiculoAlterado: false,
      };
    },
    // Mesma regra de equipamentos_conexao_view.firmware_permitido (par ativo na lista).
    // null enquanto a lista não carregou ou o veículo mudou: sem aviso precipitado.
    firmwarePermitidoForm() {
      if (this.firmwaresPermitidos == null || this.firmwareForm.veiculoAlterado) return null;
      const { version, releasedDate } = this.firmwareForm;
      if (!version || !releasedDate) return false;
      return this.firmwaresPermitidos.some((f) => f.ativo == 1
        && f.firmware_version === version && f.firmware_released_date === releasedDate);
    },
    avisoFirmware() {
      if (!this.usaIsapiNoForm || this.firmwarePermitidoForm !== false) return null;
      const { version, releasedDate } = this.firmwareForm;
      if (!version || !releasedDate) return this.$t('equipment.firmwareUnknownAlert');
      return this.$t('equipment.firmwareNotAllowedAlert', { version, releasedDate });
    },
    formTitle() {
      if (this.isBulkEdit) {
        return this.$t('equipment.bulkEditTitle', { count: this.selectedEquipamentos.length });
      }
      return this.editedIndex === -1 ? this.$t('equipment.registerEquipment') : this.$t('equipment.editEquipment');
    },
    messageConfirmButton() {
      return this.$t('button.confirm');
    },
    messageDismissButton() {
      return this.$t('button.dismiss');
    },
    classeAtual() {
      return [CLASSE_RASTREADOR, CLASSE_VALIDADOR, CLASSE_OUTRO].includes(this.mainTab) ? this.mainTab : null;
    },
    equipamentosNoRecorte() {
      const lista = Array.isArray(this.equipamentos) ? this.equipamentos : [];
      if (this.idVeiculoFiltro == null) return lista;
      return lista.filter((e) => e.id_veiculo === this.idVeiculoFiltro);
    },
    equipamentosDaAba() {
      if (!this.classeAtual) return [];
      return this.equipamentosNoRecorte.filter((e) => classeDoEquipamento(e) === this.classeAtual);
    },
    // Resumo do veículo filtrado: todas as classes, ativos e inativos.
    equipamentosDoVeiculo() {
      return this.idVeiculoFiltro == null ? [] : this.equipamentosNoRecorte;
    },
    contagemPorClasse() {
      const conta = { [CLASSE_RASTREADOR]: 0, [CLASSE_VALIDADOR]: 0, [CLASSE_OUTRO]: 0 };
      this.equipamentosNoRecorte.forEach((e) => {
        if (this.mostrarInativos || e.ativo == 1) conta[classeDoEquipamento(e)] += 1;
      });
      return conta;
    },
    abas() {
      const abas = [
        { key: CLASSE_RASTREADOR, label: this.$t('equipment.panel.tabs.trackers'), icon: ICONE_CLASSE[CLASSE_RASTREADOR],
          count: this.contagemPorClasse[CLASSE_RASTREADOR], help: this.$t('equipment.help.trackersTab') },
        { key: CLASSE_VALIDADOR, label: this.$t('equipment.panel.tabs.validators'), icon: ICONE_CLASSE[CLASSE_VALIDADOR],
          count: this.contagemPorClasse[CLASSE_VALIDADOR], help: this.$t('equipment.help.validatorsTab') },
      ];
      // Outros só quando algum tipo foi classificado assim.
      if ((this.equipamentos || []).some((e) => classeDoEquipamento(e) === CLASSE_OUTRO)) {
        abas.push({ key: CLASSE_OUTRO, label: this.$t('equipment.panel.tabs.others'), icon: ICONE_CLASSE[CLASSE_OUTRO],
          count: this.contagemPorClasse[CLASSE_OUTRO] });
      }
      abas.push({ key: 'KITS', label: this.$t('equipment.kit.tabLabel'), icon: 'mdi-package-variant-closed', count: null });
      return abas;
    },
    tituloAba() {
      const aba = this.abas.find((a) => a.key === this.mainTab);
      return aba ? aba.label : this.$t('equipment.title');
    },
    permissoesCadastro() {
      return { inserir: this.canInsert, editar: this.canEdit, excluir: this.canDelete };
    },
    permissoesValidadores() {
      const pode = (rota) => this.user?.is_superadmin === 1 || this.rotasUsuario.has(rota);
      return {
        ...this.permissoesCadastro,
        sincronizar: pode('/api/v1.0/isapi/forcasyncisapi'),
        reprocessar: pode('/api/v1.0/isapi/reaplicaisapierro'),
        reaplicarHikcentral: pode('/api/v1.0/hikvision/reaplyaccesslevel'),
        firmwares: pode('/api/v1.0/isapi/getallfirmwarespermitidos'),
      };
    },
    isapiNaInstalacao() {
      return this.setup.has_isapi == 1 || this.setup.suite_comunicacao_default === 'ISAPI';
    },
    ouvintesCadastro() {
      return {
        novo: this.abrirNovo,
        editar: this.editItem,
        excluir: this.deleteItem,
        status: this.updateStatus,
        'bulk-edit': this.openBulkEdit,
        'qr-download': this.openDownloadQRDialog,
        saveBulk: this.saveBulk,
        refresh: this.populaEquipamentos,
      };
    },
    imgSrc() {
      return ApiBaseUrl + '/';
    },
    qrcodeImageSrc() {
      if (this.editedItem.qrcode_uri) {
        const path = this.editedItem.qrcode_uri.startsWith('/static/')
          ? this.editedItem.qrcode_uri.substring('/static/'.length)
          : this.editedItem.qrcode_uri;
        return this.imgSrc + path;
      }
      return this.qrcodePreviewUrl || undefined;
    },
    headersCSV() {
      return [
        { text: this.$t('equipment.csvHeaders.lineNumber'), value: "line_number", error: "error_line" },
        { text: this.$t('equipment.csvHeaders.company'), value: "cod_empresa", error: "error_empresa" },
        { text: this.$t('equipment.csvHeaders.name'), value: "nome_equipamento", error: "error_nome_equipamento" },
        { text: this.$t('equipment.csvHeaders.code'), value: "cod_equipamento", error: "error_cod_equipamento" },
        { text: this.$t('equipment.csvHeaders.type'), value: "nome_tipo_equipamento", error: "error_tipo_equipamento" },
        { text: this.$t('equipment.csvHeaders.serialNumber'), value: "numero_serie", error: "error_numero_serie" },
        { text: this.$t('equipment.csvHeaders.active'), value: "ativo", error: "error_ativo" },
        { text: this.$t('equipment.csvHeaders.model'), value: "modelo", error: "error_modelo" }];
    },
    helpCSV() {
      return [
        { 
          label: this.$t('equipment.helpCSV.company.label'), 
          description: this.$t('equipment.helpCSV.company.description'), 
          example: this.$t('equipment.helpCSV.company.example'), 
          key: "cnpj" 
        },
        { 
          label: this.$t('equipment.helpCSV.name.label'), 
          description: this.$t('equipment.helpCSV.name.description'), 
          example: this.$t('equipment.helpCSV.name.example'), 
          key: "nome_equipamento" 
        },
        { 
          label: this.$t('equipment.helpCSV.code.label'), 
          description: this.$t('equipment.helpCSV.code.description'), 
          example: this.$t('equipment.helpCSV.code.example'), 
          key: "cod_equipamento" 
        },
        { 
          label: this.$t('equipment.helpCSV.type.label'), 
          description: this.$t('equipment.helpCSV.type.description'), 
          example: this.$t('equipment.helpCSV.type.example'), 
          key: "nome_tipo_equipamento"  
        },
        { 
          label: this.$t('equipment.helpCSV.serialNumber.label'), 
          description: this.$t('equipment.helpCSV.serialNumber.description'), 
          example: this.$t('equipment.helpCSV.serialNumber.example'), 
          key: "numero_serie" 
        },
        { 
          label: this.$t('equipment.helpCSV.active.label'), 
          description: this.$t('equipment.helpCSV.active.description'), 
          example: this.$t('equipment.helpCSV.active.example'), 
          key: "ativo" 
        },
        { 
          label: this.$t('equipment.helpCSV.model.label'), 
          description: this.$t('equipment.helpCSV.model.description'), 
          example: this.$t('equipment.helpCSV.model.example'), 
          key: "modelo" 
        }];
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.ensureQrcodePoolIfNeeded();
        this.refreshQrcodePreview();
        this.$nextTick(() => {
          this.syncLazySelects();
          if (!this.isBulkEdit && this.editedIndex === -1) {
            this.applySingleEmpresaIfOnlyOption();
          }
        });
      } else {
        this.qrcodePreviewUrl = null;
        this.close();
      }
    },
    empresas() {
      if (this.dialog && !this.isBulkEdit && this.editedIndex === -1) {
        this.$nextTick(() => this.applySingleEmpresaIfOnlyOption());
      }
    },
    '$route.query.equipamento'() {
      this.aplicaEquipamentoDaRota();
    },
    '$i18n.locale'() {
      this.initialize();
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
    },
    'editedItem.id_veiculo'() {
      this.updateSuggestedEquipmentName();
    },
    'editedItem.id_tipo_equipamento'() {
      this.updateSuggestedEquipmentName();
    },
    'editedItem.codigo_qrcode'(code) {
      if (code && typeof code === 'string' && code.trim() !== '') {
        QRCode.toDataURL(code.trim(), { width: 300, margin: 1, errorCorrectionLevel: 'H' })
          .then((url) => {
            this.qrcodePreviewUrl = url;
          })
          .catch(() => {
            this.qrcodePreviewUrl = null;
          });
      } else {
        this.qrcodePreviewUrl = null;
      }
    }
  },
  created() {
    this.user = JSON.parse(sessionStorage.getItem("user"));
    this.token = sessionStorage.getItem("api");
    this.populaRecursos();
  },
  mounted() { },
  methods: {

    allowedUnidadeIdsUsuario() {
      const ids = new Set();
      (this.recursos || []).forEach((r) => {
        if (r == null || r.id_unidade == null || r.id_unidade === '') return;
        const n = Number(r.id_unidade);
        if (Number.isFinite(n) && n > 0) ids.add(n);
      });
      return Array.from(ids);
    },
    getEquipamentoUnidadeIds(item) {
      if (!item) return [];
      const set = new Set();
      const add = (raw) => {
        if (raw == null || raw === '') return;
        if (typeof raw === 'object' && raw.id_unidade != null) {
          const n = Number(raw.id_unidade);
          if (Number.isFinite(n) && n > 0) set.add(n);
          return;
        }
        const n = Number(raw);
        if (Number.isFinite(n) && n > 0) set.add(n);
      };
      if (item.id_unidade != null && item.id_unidade !== '' && Number(item.id_unidade) !== -1) {
        add(item.id_unidade);
      }
      if (Array.isArray(item.unidades)) {
        item.unidades.forEach(add);
      } else if (item.unidades != null && String(item.unidades).trim() !== '') {
        String(item.unidades).split(',').forEach((part) => add(String(part).trim()));
      }
      if (item.ids_unidades != null && String(item.ids_unidades).trim() !== '') {
        String(item.ids_unidades).split(',').forEach((part) => add(String(part).trim()));
      }
      return Array.from(set);
    },
    applySingleEmpresaIfOnlyOption() {
      if (!this.dialog || this.isBulkEdit || this.editedIndex !== -1) {
        return;
      }
      if (this.editedItem.id_empresa != null && this.editedItem.id_empresa !== '') {
        return;
      }
      if (!Array.isArray(this.empresas) || this.empresas.length !== 1) {
        return;
      }
      this.editedItem.id_empresa = this.empresas[0].id_empresa;
    },
    populaRecursos() {
      if (this.user.is_superadmin === 1) {
        apiController.request(apiController.endpoints.getallRecursos, {
          onSuccess: (response) => {
            this.recursos = response.data;
            this.canEdit = true;
            this.canInsert = true;
            this.canDelete = true;
            this.initialize();
          },
        });
      } else {
        apiController.request(apiController.endpoints.getRecursosusuario, {
          params: { id: this.user.id_usuario },
          onSuccess: (response) => {
            this.recursos = response.data;
            this.rotasUsuario = new Set((this.recursos || []).map((r) => r.rota));
            this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updateequipamento");
            this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/insertequipamento");
            this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deleteequipamento");
            this.initialize();
          },
        });
      }
    },
    initialize() {
      this.populaEquipamentos();
      this.populaEmpresas();
      this.populaTiposEquipamentos();
      this.populaSetup();
      this.populaStatusEquipamentos();
  },
    populaSuitesComunicacao() {
      apiController.request(apiController.endpoints.isapiGetallSuitescomunicacao, {
        onSuccess: (response) => {
          this.suitesComunicacao = response.data;
        },
        onError: () => {
          this.suitesComunicacao = [];
        },
      });
    },
    populaFirmwaresPermitidos() {
      apiController.request(apiController.endpoints.isapiGetallFirmwarespermitidos, {
        silent: true,
        onSuccess: (response) => {
          this.firmwaresPermitidos = response.data;
        },
        onError: () => {
          // Sem a lista o form não avisa (não dá para afirmar que o firmware é bloqueado).
          this.firmwaresPermitidos = null;
        },
      });
    },
    populaProvedoresIp() {
      apiController.request(apiController.endpoints.isapiGetallProvedoresip, {
        onSuccess: (response) => {
          this.provedoresIp = response.data;
        },
        onError: () => {
          this.provedoresIp = [];
        },
      });
    },
    populaSetup() {
      apiController.request(apiController.endpoints.getallParametrossetup, {
        onSuccess: (response) => {
          this.setup = response.data[0];
          if (this.setup.has_hikvision == 1) {
            this.populaNiveisAcesso();
          }
          if (this.mostraSuiteComunicacao) {
            this.populaSuitesComunicacao();
            this.populaFirmwaresPermitidos();
          }
          if (this.setup.has_isapi == 1) {
            this.populaProvedoresIp();
          }
        },
      });
    },
    populaEquipamentos() {
      apiController.request(apiController.endpoints.getallEquipamentos, {
        onSuccess: (response) => {
          this.equipamentos = response.data;
          this.loadingtable = false;
          this.aplicaEquipamentoDaRota();
        },
        onError: () => {
          this.loadingtable = false;
        },
      });
    },
    populaNiveisAcesso() {
      apiController.request(apiController.endpoints.hikvisionGetAccesslevellist, {
        onSuccess: (response) => {
          this.niveisAcesso = response.data.result;
        },
      });
    },
    populaEmpresas() {
      apiController.request(apiController.endpoints.getallEmpresas, {
        onSuccess: (response) => {
          this.empresas = response.data;
        },
      });
    },
    populaTiposEquipamentos() {
      apiController.request(apiController.endpoints.getallTiposequipamentos, {
        onSuccess: (response) => {
          this.tiposequipamentos = response.data;
        },
      });
    },
    populaStatusEquipamentos() {
      apiController.request(apiController.endpoints.getallStatusequipamento, {
        onSuccess: (response) => {
          this.statusEquipamentos = response.data;
        },
      });
    },
    imeiRules() {
      if (this.editedItem.imei != null && this.editedItem.imei.length > 0) {
        if (!/^[0-9]{2}-[0-9]{6}-[0-9]{6}-[0-9]{1}$/.test(this.editedItem.imei)) {
          return this.$t('equipment.invalidImei');
        } else {
          return true;
        }
      }
      return true; // IMEI is optional, so return true when empty
    },
    codEquipamentoRules() {
      if (!validador(this.editedItem.cod_equipamento, 1, 20, 0, 1)) {
        return this.$t('equipment.invalidCode');
      } else {
        return true;
      }
    },
    numeroSerieRules() {
      if (!validador(this.editedItem.numero_serie, 1, 50, 0, 0)) {
        return this.$t('equipment.invalidSerialNumber');
      } else {
        return true;
      }
    },
    modeloRules() {
      if (!validador(this.editedItem.modelo, 1, 30, 0, 0)) {
        return this.$t('equipment.invalidModel');
      } else {
        return true;
      }
    },
    filterEquipamentos(item, queryText) {
      const code = item.cod_equipamento ? item.cod_equipamento.toLowerCase() : '';
      const name = item.nome_equipamento ? item.nome_equipamento.toLowerCase() : '';
      const company = item.razao_social ? item.razao_social.toLowerCase() : '';
      const searchText = queryText.toLowerCase();
      return code.includes(searchText) || name.includes(searchText) || company.includes(searchText);
    },
    filterTiposEquipamentos(item, queryText) {
      const name = item.nome_tipo_equipamento ? item.nome_tipo_equipamento.toLowerCase() : '';
      const searchText = queryText.toLowerCase();
      return name.includes(searchText);
    },
    getCategoriaTipoEquipamento(idTipo) {
      if (idTipo == null) return '';
      const tipo = this.tiposequipamentos.find((t) => t.id_tipo_equipamento === idTipo);
      if (!tipo || tipo.categoria_tipo_equipamento == null || tipo.categoria_tipo_equipamento === '') return '';
      const cat = tipo.categoria_tipo_equipamento;
      const catId = typeof cat === 'number' ? cat : parseInt(cat, 10);
      if (!Number.isNaN(catId)) {
        const catTipo = this.tiposequipamentos.find((t) => t.id_tipo_equipamento === catId);
        return catTipo ? (catTipo.nome_tipo_equipamento || '').trim() : '';
      }
      return String(cat).trim();
    },
    updateSuggestedEquipmentName() {
      if (this.isBulkEdit || this.editedIndex !== -1) return;
      let veiculoLabel = this.editedItem.cod_veiculo
        ? String(this.editedItem.cod_veiculo).trim()
        : '';
      const veiculoRef = this.$refs.veiculoSelect;
      if (
        !veiculoLabel &&
        veiculoRef &&
        this.editedItem.id_veiculo != null &&
        veiculoRef.selectedItemCache
      ) {
        const cached = veiculoRef.selectedItemCache[this.editedItem.id_veiculo];
        if (cached && cached.cod_veiculo) {
          veiculoLabel = String(cached.cod_veiculo).trim();
        }
      }
      const tipo = this.tiposequipamentos.find((t) => t.id_tipo_equipamento === this.editedItem.id_tipo_equipamento);
      const tipoLabel = tipo && tipo.nome_tipo_equipamento ? String(tipo.nome_tipo_equipamento).trim() : '';
      const parts = [veiculoLabel, tipoLabel].filter(Boolean);
      this.editedItem.nome_equipamento = parts.length ? parts.join(' - ') : null;
    },
    onInventarioSelect(val) {
      this.editedItem.codigo_qrcode = val;
    },
    onVeiculoSelect(val) {
      this.editedItem.id_veiculo = val;
      const veiculoRef = this.isBulkEdit ? this.$refs.veiculoSelectBulk : this.$refs.veiculoSelect;
      if (veiculoRef && val != null && veiculoRef.selectedItemCache) {
        const cached = veiculoRef.selectedItemCache[val];
        this.editedItem.cod_veiculo = cached && cached.cod_veiculo ? cached.cod_veiculo : null;
      } else if (val == null) {
        this.editedItem.cod_veiculo = null;
      }
    },
    syncLazySelects() {
      const inv = this.$refs.inventarioSelect;
      if (inv) {
        const code = this.editedItem.codigo_qrcode;
        if (code != null && String(code).trim() !== '') {
          inv.cacheSelectedItems([{ codigo: code }], 'codigo');
          inv.setData(code);
        } else {
          inv.resetData();
        }
        inv.loadLazyItems('');
      }
      const syncVeiculo = (ref) => {
        if (!ref) return;
        if (this.editedItem.id_veiculo != null) {
          ref.cacheSelectedItems(
            [{
              id_veiculo: this.editedItem.id_veiculo,
              cod_veiculo: this.editedItem.cod_veiculo,
            }],
            'id_veiculo'
          );
          ref.setData(this.editedItem.id_veiculo);
        } else {
          ref.resetData();
        }
        ref.loadLazyItems('');
      };
      syncVeiculo(this.$refs.veiculoSelect);
      syncVeiculo(this.$refs.veiculoSelectBulk);
    },
    // As abas emitem a linha decorada para exibição (campos *_extenso, traços no lugar de
    // nulo): formulário e gravações partem sempre do registro da listagem.
    registroOriginal(item) {
      if (!item) return item;
      return (this.equipamentos || []).find((e) => e.id_equipamento === item.id_equipamento) || item;
    },
    editItem(linha) {
      const item = this.registroOriginal(linha);
      this.isBulkEdit = false;
      this.editedIndex = this.equipamentos.indexOf(item);
      // A listagem não traz senha_isapi; ela precisa existir já na atribuição para o Vue
      // observar a chave (senão o aviso de pendências não reage à senha digitada).
      this.editedItem = Object.assign({}, item, { senha_isapi: null });
      this.idVeiculoOriginal = item.id_veiculo;
      this.mostraSenhaIsapi = false;
      if (this.editedItem.porta_isapi == null) {
        this.editedItem.porta_isapi = 443;
      }
      if (this.editedItem.ativo == 1) {
        this.isAtivo = true;
      } else {
        this.isAtivo = false;
      }
      this.dialog = true;
    },
    abrirNovo() {
      this.isBulkEdit = false;
      this.editedIndex = -1;
      this.editedItem = Object.assign({}, this.defaultItem);
      // Cadastro aberto com um veículo filtrado já nasce nele; na aba de uma classe com um
      // único tipo, o tipo também vem escolhido.
      if (this.idVeiculoFiltro != null) {
        this.editedItem.id_veiculo = this.idVeiculoFiltro;
        this.editedItem.cod_veiculo = this.codVeiculoFiltro;
      }
      const tiposDaClasse = (this.tiposequipamentos || [])
        .filter((t) => t.ativo != 0 && classeDoEquipamento(t) === this.classeAtual);
      if (tiposDaClasse.length === 1) {
        this.editedItem.id_tipo_equipamento = tiposDaClasse[0].id_tipo_equipamento;
      }
      this.isAtivo = true;
      this.dialog = true;
    },
    onFiltroVeiculo(val) {
      this.idVeiculoFiltro = val != null ? val : null;
      const ref = this.$refs.filtroVeiculo;
      const cache = ref && ref.selectedItemCache && val != null ? ref.selectedItemCache[val] : null;
      this.codVeiculoFiltro = cache && cache.cod_veiculo ? cache.cod_veiculo : null;
    },
    // Fixa o filtro de veículo por código (vindo da rota ou do resumo), sem passar pelo select.
    aplicaFiltroVeiculo(idVeiculo, codVeiculo) {
      const ref = this.$refs.filtroVeiculo;
      if (ref) {
        if (idVeiculo != null) {
          ref.cacheSelectedItems([{ id_veiculo: idVeiculo, cod_veiculo: codVeiculo }], 'id_veiculo');
          ref.setData(idVeiculo);
        } else {
          ref.resetData();
        }
      }
      this.idVeiculoFiltro = idVeiculo;
      this.codVeiculoFiltro = codVeiculo || null;
    },
    abrirDoResumo({ classe, item }) {
      if (item && item.ativo != 1) this.mostrarInativos = true;
      this.mainTab = classe;
    },
    // /equipamentos?equipamento=<id> (ex.: clique num alerta de equipamento): abre a aba da
    // classe dele, já no veículo em que ele está.
    aplicaEquipamentoDaRota() {
      const bruto = this.$route && this.$route.query ? this.$route.query.equipamento : null;
      if (bruto == null || bruto === '' || bruto === this.equipamentoRotaAplicado) return;
      const id = Number(bruto);
      const item = (this.equipamentos || []).find((e) => Number(e.id_equipamento) === id);
      if (!item) return;
      this.equipamentoRotaAplicado = bruto;
      if (item.ativo != 1) this.mostrarInativos = true;
      this.mainTab = classeDoEquipamento(item);
      if (item.id_veiculo != null) {
        this.$nextTick(() => this.aplicaFiltroVeiculo(item.id_veiculo, item.cod_veiculo));
      }
    },
    limpaSelecaoAbas() {
      ['tabelaClasse', 'painelValidadores'].forEach((ref) => {
        const alvo = this.$refs[ref];
        if (alvo && typeof alvo.limpaSelecao === 'function') alvo.limpaSelecao();
      });
    },
    openBulkEdit(selecionados) {
      if (Array.isArray(selecionados)) this.selectedEquipamentos = selecionados.map((l) => this.registroOriginal(l));
      if (!this.selectedEquipamentos || this.selectedEquipamentos.length === 0) return;
      this.isBulkEdit = true;
      this.editedIndex = -1;
      const first = this.selectedEquipamentos[0];
      this.editedItem = Object.assign({}, first);
      this.isAtivo = this.editedItem.ativo == 1;
      this.dialog = true;
    },
    deleteItem(linha) {
      const item = this.registroOriginal(linha);
      this.deletedItem = Object.assign({}, item);
      this.mensagemdialog =
        this.$t('equipment.confirmDelete', { equip: item.cod_equipamento });
      this.showConfirmButton = true;
      this.confirmDialogType = 'delete';
      this.messageDismissButton = this.$t('button.dismiss');
      this.messageConfirmButton = this.$t('button.confirm');
      this.confirmDialog = true;
    },
    deleteFromDatabase() {
      this.operacao = 2;
      this.confirmDialog = false;
      apiController.request(apiController.endpoints.deleteEquipamento, {
        data: this.deletedItem,
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
      });
    },
    close() {
      this.dialog = false;
      this.isBulkEdit = false;
      this.mostraSenhaIsapi = false;
      this.$nextTick(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.deletedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
        this.idVeiculoOriginal = null;
        this.isAtivo = true;
        if (this.$refs.inventarioSelect && typeof this.$refs.inventarioSelect.resetData === 'function') {
          this.$refs.inventarioSelect.resetData();
        }
        if (this.$refs.veiculoSelect && typeof this.$refs.veiculoSelect.resetData === 'function') {
          this.$refs.veiculoSelect.resetData();
        }
        if (this.$refs.veiculoSelectBulk && typeof this.$refs.veiculoSelectBulk.resetData === 'function') {
          this.$refs.veiculoSelectBulk.resetData();
        }
        if (this.$refs.form) {
          this.$refs.form.resetValidation();
        }
      });
    },
    save() {
      this.$refs.form.validate();
      if (this.formValidado) {
        if (this.isAtivo) {
          this.editedItem.ativo = 1;
        } else {
          this.editedItem.ativo = 0;
        }
        if (this.isBulkEdit && this.selectedEquipamentos && this.selectedEquipamentos.length > 0) {
          this.operacao = 1;
          const bulkPayload = {
            id_empresa: this.editedItem.id_empresa,
            id_status_equipamento: this.editedItem.id_status_equipamento,
            id_veiculo: this.editedItem.id_veiculo,
            ativo: this.editedItem.ativo,
          };
          const promises = this.selectedEquipamentos.map((item) => {
            const payload = { ...item, ...bulkPayload };
            if (payload.numero_ordem === "Nenhum") payload.numero_ordem = null;
            return apiController.request(apiController.endpoints.updateEquipamento, { data: payload, silent: true });
          });
          (async () => {
            try {
              const responses = await Promise.all(promises);
              const hasError = responses.some((r) => r.data && r.data.erro);
              if (!hasError) {
                this.selectedEquipamentos = [];
                this.limpaSelecaoAbas();
              }
              this.updateTable(hasError);
            } catch (e) {
              console.log(e);
              EventBus.$emit('show-error', { error: e });
            }
          })();
          return;
        }
        if (this.editedIndex == -1) {
          this.operacao = 0;
          const emptyCode = (v) => v == null || (typeof v === 'string' && v.trim() === '');
          const needPoolCode = emptyCode(this.editedItem.codigo_qrcode);
          const ensurePoolThenInsert = () => {
            const insertPayload = { ...this.editedItem };
            apiController.request(apiController.endpoints.insertEquipamento, {
              data: insertPayload,
              onSuccess: (response) => {
                this.updateTable(response.data.erro);
              },
            });
          };
          if (needPoolCode) {
            this.ensureQrcodePoolIfNeeded().then(() => ensurePoolThenInsert());
          } else {
            ensurePoolThenInsert();
          }
        } else {
          this.operacao = 1;
          if (this.editedItem.numero_ordem == "Nenhum") {
            this.editedItem.numero_ordem = null;
          }
          apiController.request(apiController.endpoints.updateEquipamento, {
            data: this.editedItem,
            onSuccess: (response) => {
              console.log(this.editedItem);
              console.log(response);
              this.updateTable(response.data.erro);
            },
          });
        }
      }
    },
    updateTable(status) {
      if (status) {
        if (this.operacao == 0) {
          EventBus.$emit('show-alert', { mensagem: this.$t('equipment.updateTable.error.insert'), tipo: 'error' });
        } else {
          if (this.operacao == 1) {
            EventBus.$emit('show-alert', { mensagem: this.$t('equipment.updateTable.error.update'), tipo: 'error' });
          } else {
            EventBus.$emit('show-alert', { mensagem: this.$t('equipment.updateTable.error.delete'), tipo: 'error' });
          }
        }
      } else {
        if (this.operacao == 0) {
          EventBus.$emit('show-alert', { mensagem: this.$t('equipment.updateTable.success.insert'), tipo: 'success' });
        } else {
          if (this.operacao == 1) {
            EventBus.$emit('show-alert', { mensagem: this.$t('equipment.updateTable.success.update'), tipo: 'success' });
          } else {
            EventBus.$emit('show-alert', { mensagem: this.$t('equipment.updateTable.success.delete'), tipo: 'success' });
          }
        }
        this.editedItem = this.defaultItem;
      }
      this.close();
      this.populaEquipamentos();
    },
    saveBulk(equipamentos) {
      if (!equipamentos || equipamentos.length === 0) return;
      var valid = equipamentos.filter(function (e) {
        return !e.error_empresa && !e.error_nome_equipamento && !e.error_cod_equipamento &&
          !e.error_tipo_equipamento && !e.error_ativo && !e.error_modelo;
      });
      if (valid.length === 0) return;
      var temp = valid.map(function (e) {
        return [
          e.nome_equipamento,
          e.cod_equipamento,
          e.numero_serie,
          e.id_empresa,
          e.id_tipo_equipamento,
          null,
          null,
          e.ativo != null ? e.ativo : 1,
          null,
          null,
          e.modelo,
          null,
          e.codigo_qrcode
        ];
      });
      this.operacao = 0;
      apiController.request(apiController.endpoints.insertEquipamentosbulk, {
        data: temp,
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
          this.populaEquipamentos();
        },
      });
    },
    submitFile() {
      this.$refs.form.validate();
      if (this.formValidado) {
        let formData = new FormData();

        this.mensagemUpload = this.$t('system.messages.loadingFile');
        this.fileLoading = true;
        if (this.arquivoCsv) {
          formData.append("arquivocsv", this.arquivoCsv);
          apiController.request(apiController.endpoints.uploadCsv, {
            data: formData,
            headers: {
              "Content-Type": `multipart/form-data; boundary=${formData._boundary}`,
              "x-access-token": this.token,
            },
            onSuccess: (response) => {
              console.log(response);
              this.fileLoading = false;
              this.mensagemUpload = null;
            },
          });
        } else {
          console.log(this.$t('equipment.noFiles'));
        }
      }
    },
    processaArquivo() {
      this.mensagemUpload = this.$t('system.messages.processingFile');
      apiController.request(apiController.endpoints.processaCsvequipamentos, {
        params: { file: this.idempresaupload, idusuario: this.arquivoCsv.name },
        onSuccess: (response) => {
          console.log(response);
          this.mensagemUpload = this.$t('system.messages.fileProcessedSuccess');
          this.fileLoading = false;
          this.fimProcesso = true;
          this.arquivoLog = response.data.arqlog;
          this.initialize();
        },
        onError: () => {
          this.fileLoading = false;
        },
      });
    },
    updateStatus(linha) {
      const item = this.registroOriginal(linha);
      if (this.statusEquipamentos.length === 0) {
        EventBus.$emit('show-alert', { mensagem: this.$t('equipment.updateTable.error.noStatusAvailable'), tipo: 'error' });
        return;
      }

      // Find current status index
      const currentStatusId = item.id_status_equipamento;
      const currentIndex = this.statusEquipamentos.findIndex(
        status => status.id_status_equipamento === currentStatusId
      );

      // Determine next status index (cycle to first if at the end)
      let nextIndex;
      if (currentIndex === -1 || currentIndex === this.statusEquipamentos.length - 1) {
        // If no current status or at last status, go to first
        nextIndex = 0;
      } else {
        // Move to next status
        nextIndex = currentIndex + 1;
      }

      // Get next status
      const nextStatus = this.statusEquipamentos[nextIndex];
      const currentStatus = currentIndex >= 0 ? this.statusEquipamentos[currentIndex] : null;
      
      // Store information for confirmation
      this.editedItem = Object.assign({}, item);
      this.nextStatusInfo = {
        nextStatus: nextStatus,
        currentStatus: currentStatus
      };
      
      // Show confirmation dialog
      const currentStatusText = currentStatus ? currentStatus.descricao_status_equipamento : this.$t('equipment.noStatus');
      const nextStatusText = nextStatus.descricao_status_equipamento;
      this.mensagemdialog = this.$t('equipment.confirmStatusUpdate', { 
        equip: item.cod_equipamento,
        current: currentStatusText,
        next: nextStatusText
      });
      this.showConfirmButton = true;
      this.confirmDialogType = 'status';
      this.messageDismissButton = this.$t('button.dismiss');
      this.messageConfirmButton = this.$t('button.confirm');
      this.confirmDialog = true;
    },
    confirmStatusUpdate() {
      if (!this.nextStatusInfo) {
        this.confirmDialog = false;
        return;
      }

      this.confirmDialog = false;
      this.operacao = 1;
      
      // Update equipment status
      this.editedItem.id_status_equipamento = this.nextStatusInfo.nextStatus.id_status_equipamento;

      apiController.request(apiController.endpoints.updateEquipamento, {
        data: this.editedItem,
        onSuccess: (response) => {
          this.updateTable(response.data.erro);
        },
      });

      // Clear stored status info
      this.nextStatusInfo = null;
    },
    async ensureQrcodePoolIfNeeded() {
      if (this.isBulkEdit || this.editedIndex !== -1) {
        return;
      }
      try {
        await apiController.request(apiController.endpoints.ensureqrcodepool, { silent: true });
        const inv = this.$refs.inventarioSelect;
        if (inv && typeof inv.loadLazyItems === 'function') {
          inv.loadLazyItems(inv.lazySearch || '');
        }
      } catch (e) {
        console.error('Error ensuring equipment QR code pool:', e);
      }
    },
    openQRScanner() {
      this.qrScannerError = null;
      this.qrScannerDialog = true;
    },
    closeQRScanner() {
      this.qrScannerDialog = false;
      this.qrScannerError = null;
      this.qrCamera = 'auto';
    },
    onQRDecode(decodedString) {
      try {
        this.editedItem.codigo_qrcode = decodedString;
        const inv = this.$refs.inventarioSelect;
        if (inv) {
          inv.cacheSelectedItems([{ codigo: decodedString }], 'codigo');
          inv.setData(decodedString);
        }
        this.closeQRScanner();
        EventBus.$emit('show-alert', {
          mensagem: this.$t('equipment.qrScanner.success'),
          tipo: 'success'
        });
      } catch (error) {
        this.qrScannerError = this.$t('equipment.qrScanner.invalidJSON');
        console.error('Error parsing QR code:', error);
      }
    },
    onQRInit(promise) {
      promise
        .then(() => {
          // Camera initialized successfully
          this.qrScannerError = null;
        })
        .catch((error) => {
          // Handle camera initialization errors
          let errorMessage = this.$t('equipment.qrScanner.cameraError');
          
          if (error.name === 'NotAllowedError') {
            errorMessage = this.$t('equipment.qrScanner.cameraPermissionDenied');
          } else if (error.name === 'NotFoundError') {
            errorMessage = this.$t('equipment.qrScanner.cameraNotFound');
          } else if (error.name === 'NotReadableError') {
            errorMessage = this.$t('equipment.qrScanner.cameraNotReadable');
          } else if (error.name === 'OverconstrainedError') {
            errorMessage = this.$t('equipment.qrScanner.cameraConstraints');
          }
          
          this.qrScannerError = errorMessage;
          EventBus.$emit('show-alert', {
            mensagem: errorMessage,
            tipo: 'error'
          });
        });
    },
    downloadIndividualQRCode() {
      if (!this.editedItem.id_equipamento) {
        EventBus.$emit('show-alert', {
          mensagem: this.$t('equipment.qrcode.noEquipmentSelected'),
          tipo: 'error'
        });
        return;
      }

      this.downloadingIndividualQRCode = true;

      apiController.request(apiController.endpoints.downloadQrcodeequipamento, {
        params: { id_equipamento: this.editedItem.id_equipamento },
        config: { responseType: 'blob' },
        silent: true,
        onSuccess: (response) => {
          // Create a blob from the response
          const blob = new Blob([response.data], { type: 'image/png' });
          const url = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          const filename = (this.editedItem.qrcode_no || this.editedItem.numero_serie || 'qrcode') + '.png';
          link.setAttribute('download', filename);
          document.body.appendChild(link);
          link.click();
          link.remove();
          window.URL.revokeObjectURL(url);

          this.downloadingIndividualQRCode = false;

          EventBus.$emit('show-alert', {
            mensagem: this.$t('equipment.qrcode.downloadSuccess'),
            tipo: 'success'
          });
        },
        onError: (e) => {
          this.downloadingIndividualQRCode = false;

          // Try to parse error message from response (when responseType is blob, errors come as blob too)
          if (e.response && e.response.data) {
            // Check if it's a Blob
            if (e.response.data instanceof Blob) {
              const reader = new FileReader();
              reader.onload = () => {
                try {
                  const errorData = JSON.parse(reader.result);
                  EventBus.$emit('show-alert', {
                    mensagem: errorData.mensagem || (this.$t('equipment.qrcode.downloadError')),
                    tipo: 'error'
                  });
                } catch (parseError) {
                  EventBus.$emit('show-alert', {
                    mensagem: this.$t('equipment.qrcode.downloadError'),
                    tipo: 'error'
                  });
                }
              };
              reader.readAsText(e.response.data);
            } else {
              EventBus.$emit('show-alert', {
                mensagem: e.response.data.mensagem || (this.$t('equipment.qrcode.downloadError')),
                tipo: 'error'
              });
            }
          } else {
            EventBus.$emit('show-alert', {
              mensagem: this.$t('equipment.qrcode.downloadError'),
              tipo: 'error'
            });
          }
        },
      });
    },
    openDownloadQRDialog() {
      this.downloadQRDialogOpen = true;
    },
    refreshQrcodePreview() {
      const code = this.editedItem.codigo_qrcode;
      if (code && typeof code === 'string' && code.trim() !== '') {
        QRCode.toDataURL(code.trim(), { width: 300, margin: 1, errorCorrectionLevel: 'H' })
          .then((url) => {
            this.qrcodePreviewUrl = url;
          })
          .catch(() => {
            this.qrcodePreviewUrl = null;
          });
      } else {
        this.qrcodePreviewUrl = null;
      }
    },
  },
};
</script>

<style scoped>
.equipamentos-topo {
  border-radius: 10px;
  overflow: hidden;
}
.crud-kits-embed >>> .v-container {
  margin-top: 0 !important;
}
.secao-form {
  display: flex;
  align-items: center;
  margin: 16px 0 4px;
  padding-bottom: 4px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  font-size: 0.95rem;
  font-weight: 500;
}
.secao-form:first-child {
  margin-top: 0;
}
.subsecao-form {
  margin-top: 12px;
  font-size: 0.875rem;
  font-weight: 500;
}
</style>
